import React from 'react';
import BWAccordion from 'components/shared/BWAccordion';
import FormInput from 'components/shared/BWFormControl/FormInput';

const WarrantyPeriodStatus = ({ disabled }) => (
  <BWAccordion title='Trạng thái'>
    <label className='bw_checkbox'>
      <FormInput type='checkbox' field='is_active' disabled={disabled} />
      <span />
      Kích hoạt
    </label>
  </BWAccordion>
);

export default WarrantyPeriodStatus;
